/**
 * Rodar a MESMA ação para vários itens, um de cada vez.
 *
 * Por que um de cada vez e não `Promise.all`: as ações em lote desta tela (varrer pessoas,
 * vincular grupo à campanha) falam com o WhatsApp pelo monitorador. Disparar 50 ao mesmo
 * tempo é pedir para o número ser tratado como robô — e o provider responde mal (lista
 * vazia, timeout) justamente quando está sobrecarregado. Em fila, cada grupo passa pelas
 * mesmas regras do botão da linha, e uma falha não derruba as outras.
 */
export interface SequentialOutcome<T, R> {
  ok: { item: T; result: R }[];
  failed: { item: T; error: unknown }[];
}

export async function runInSequence<T, R>(
  items: readonly T[],
  action: (item: T) => Promise<R>,
  onProgress?: (done: number, total: number) => void,
): Promise<SequentialOutcome<T, R>> {
  const outcome: SequentialOutcome<T, R> = { ok: [], failed: [] };
  onProgress?.(0, items.length);
  for (const [index, item] of items.entries()) {
    try {
      outcome.ok.push({ item, result: await action(item) });
    } catch (error) {
      outcome.failed.push({ item, error });
    }
    onProgress?.(index + 1, items.length);
  }
  return outcome;
}

/** Ordem de nome como gente lê: "#9" antes de "#10", e sem diferença por acento/caixa. */
export function compareNatural(a: string, b: string): number {
  return a.localeCompare(b, 'pt-BR', { numeric: true, sensitivity: 'base' });
}
